{
  "title": "Activity Tracking",
  "manageFiltersButton": "Manage Filters",
  "refreshButton": "Refresh",
  "exportReportButton": "Export Report",
  "ariaLabel": "activity tabs",
  "tabs": {
    "weeklyActivity": "Weekly Activity",
    "recentActivity": "Recent Activity",
    "fboActivity": "FBO Activity"
  },
  "dialog": {
    "title": "Manage Activity Filters"
  },
  "errors": {
    "loadFailed": "Failed to load activity data"
  }
}
